import React from "react";

function ChoosePaymentMethod() {
  return <></>;
}

export default ChoosePaymentMethod;
